<article class="news-modal">

  <!-- Header image -->
  <!-- <header class="news-modal-hero" *ngIf="coverUrl()">
    <img [src]="coverUrl('medium')" [alt]="item?.coverImage?.alternativeText || item?.name?.th">
    <div class="news-modal-hero-gradient"></div>

    <button mat-icon-button class="news-modal-close hero-close" (click)="onClose()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>

    <div class="news-modal-hero-text">
      <span class="news-modal-date" *ngIf="item?.createdDate">
        {{ item.createdDate | date:'d MMMM yyyy' }}
      </span>
      <h2 class="news-modal-title">{{ item?.name?.th }}</h2>
    </div>
  </header> -->

  <!-- Fallback header (no image) -->
  <header class="news-modal-header-plain">
    <button mat-icon-button class="news-modal-close plain-close" (click)="onClose()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
    <span class="news-modal-date" *ngIf="item?.createdDate">
      {{ item.createdDate | date:'d MMMM yyyy' }}
    </span>
    <h2 class="news-modal-title">{{ item?.name?.th }}</h2>
  </header>

  <!-- Body Content -->
  <mat-dialog-content class="news-modal-body">
    <p class="news-modal-desc" *ngIf="item?.description?.th">
      {{ item.description.th }}
    </p>

    <div class="news-modal-tags" *ngIf="item?.tags?.length">
      <span class="news-tag" *ngFor="let tag of item.tags">{{ tag.nameTh }}</span>
    </div>

    <mat-divider class="content-divider" *ngIf="item?.description?.th || item?.tags?.length"></mat-divider>

    <!-- Rich Text Area -->
    <section class="news-modal-details" [innerHTML]="safeDetails"></section>
  </mat-dialog-content>

  <!-- Footer -->
  <mat-dialog-actions align="end" class="news-modal-footer">
    <button mat-flat-button color="primary" class="close-btn" (click)="onClose()">ปิด (Close)</button>
  </mat-dialog-actions>

</article>